class TidalSituation {
  static toName = (id: string): string => {
    switch(id) {
      case 'unspecified': return "Unspecified";
      case 'na': return "N/A";
      case 'high': return "High";
      case 'low': return "Low";
      case 'ebb': return "Ebb";
      case 'flood': return "Flood";
      case 'cycle': return "Cycle";
      case 'other': return "Other";
      default: return "Unknown tidal situation";
    }
  }

  static getList = (): string[] => {
    return [
      'high',
      'low',
      'ebb',
      'flood',
      'cycle',
      'other',
      'unspecified',
      'na'
    ];
  }
}

export { TidalSituation }